module.exports = __webpack_public_path__ + "static/img/78118C_3_C_20230802_LC.7eafdaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/78118C_3_C_20230802_LC.png
// module id = H8LV
// module chunks = 0